import { FieldProps, useRecordContext } from "react-admin";

// import { Customer } from "../types";
import FullNameField from "./FullNameField";

const CustomerLinkField = ({ source = "iUserId" }: FieldProps<any>) => {
  void source;
  const record = useRecordContext<any>();
  if (!record) {
    return null;
  }
  return <FullNameField />;
};

export default CustomerLinkField;
